import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { UserSettingsProfiloComponent } from './gestione-profilo';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('usersettings.gestione-profilo', {
            url: '/gestione-profilo',
            views: {
                'userContent': {
                    template: '<gestione-profilo></gestione-profilo>'
                }
            },
            ncyBreadcrumb: {
                label: 'Utente',
                parent: 'usersettings.index'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Utente'
            },
            resolve: {
                user: ($q, $rootScope, store: ng.a0.storage.IStoreService, UserService, $state: ng.ui.IStateService) => {
                    if ($rootScope.currentUser()) {
                        let email = $rootScope.currentUser().sub === undefined ? store.get('user').accountData.email : $rootScope.currentUser().sub;
                        return UserService.getUser(email)
                            .then((result) => {
                                return result;
                            }, (error) => {
                                return $q.reject(error);
                            });
                    }
                }
            }
        }
        );
};

stateConfig.$inject = ['$stateProvider'];

export const GestioneProfiloModule: string = ng
    .module('archiSmall.userSettings.gestioneProfiloModule', [
        'ui.bootstrap',
        uiRouter,
        'ncy-angular-breadcrumb'
    ])
    .component('gestioneProfilo', UserSettingsProfiloComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/sections/usersettings/gestione-profilo/gestione-profilo.module.ts